import { history } from "../helpers/history"
import client from "../services/feathers"

export const servicesSocket = (user, props) => {
    const userService = client.service('cusers')
    // estado del usuario
    userService.on('patched', userPatch => {
        //console.log(userPatch)
        const { id, state } = userPatch
        if (id === user.id) {
            if (!state) {
                // console.log(' mi usuario', userPatch, user)
                client.logout().then(r => {/* console.log('usuario inhabilitado ', r) */})
                history.push('/home')
            }
        } 
    })

    // notificaciones
    const notificationsService = client.service('notifications');
        notificationsService.on('created', notification => {
        })

    // parametros
    client.service('parameters').on('updated', parameter => {
        // console.log('Se actualizo el parameter', parameter)
        props.updateParams(parameter)
    })
    // parametros
    client.service('quotas').on('patched', quota => {
        if (quota.cedule === user.vusk) {
            // console.log('Se actualizo el quotas', quota)
            props.updateQuotasReduce(quota)
           //  this.props.updateParams(parameter)
        }
    
    })

    client.service('verificates').on('patched', verificate => {
        //console.log(user)
        //console.log(verificate)
        if (user.id === verificate.user) {
            client.logout().then(r => {/* (console.log('cerrando sesion ')) */})
            history.push('/home')
           //  this.props.updateParams(parameter)
        }

    })
    client.service('verificates-company').on('patched', verificate => {
        
        if (user.id === verificate.user) {
            client.logout().then(r => {/* (console.log('cerrando sesion ')) */})
            history.push('/home')
           //  this.props.updateParams(parameter)
        }

    })

    // servicios
    client.service('agreement-types').on('patched', agreementType => {
        // console.log('Se actualizo el servicio', agreementType)
        props.updateAgreementTypes(agreementType)
    })

}